import React, { useEffect, useState } from 'react';
import { RewardsType } from 'app/console-api/apps/types';
import { getRewardsTypes } from 'app/console-api/apps/rewards';
import { useTabsCtx } from 'app/components/management/apps/tabs-page-layout';
import { FormContainer, PageContainer } from 'app/components/common/common-styles';
import { FlexRow } from '@make-software/cspr-design';
import RewardsTypesControl from 'app/components/management/apps/settings/rewards/app-rewards-type-control';

export const AppRewardsPage = () => {
  const { app } = useTabsCtx();
  const [rewardsTypes, setRewardsTypes] = useState<RewardsType[]>([]);

  const { setBreadcrumbs } = useTabsCtx();

  React.useEffect(() => {
    setBreadcrumbs([
      {
        label: 'Edit Rewards'
      }
    ]);
    return () => setBreadcrumbs([]);
  }, []);

  useEffect(() => {
    if (!app) return;
    getRewardsTypes(app.id)
      .then((response) => setRewardsTypes(response.data || []))
      .catch((error: any) => {
        console.error('Failed to fetch rewards types', error);
      });
  }, [app]);
  return (
    <PageContainer>
      <FlexRow justify={'center'} align={'center'}>
        <FormContainer>
          <RewardsTypesControl initialRewards={rewardsTypes} appID={app?.id || ''} />
        </FormContainer>
      </FlexRow>
    </PageContainer>
  );
};
